import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Transition as _Transition, withCtx as _withCtx, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "socket-banner",
  role: "status",
  "aria-live": "polite",
  "aria-atomic": "true"
}
const _hoisted_2 = {
  class: "socket-banner__icon-wrap",
  "aria-hidden": "true"
}

import { computed, onBeforeUnmount, ref, watch } from "vue";
import { socketConnected } from "@/utils/socket-rooms";
import { useIncomingCall } from "@/composables/calls/useIncomingCall";
import { Icon } from "@/components/ui";

// Avoid flashing the banner on sub-second network blips (Wi-Fi handoff, sleep/wake).
const SHOW_DELAY_MS = 800;


export default /*@__PURE__*/_defineComponent({
  __name: 'SocketStatusBanner',
  setup(__props) {

const { parentCallSid } = useIncomingCall();
const isCallInFlight = computed(() => parentCallSid.value !== null);

const graceElapsed = ref(false);
let showTimer: ReturnType<typeof setTimeout> | null = null;

const clearShowTimer = () => {
  if (showTimer) {
    clearTimeout(showTimer);
    showTimer = null;
  }
};

watch(
  [socketConnected, isCallInFlight],
  ([connected, inCall]) => {
    if (connected || !inCall) {
      clearShowTimer();
      graceElapsed.value = false;
      return;
    }
    if (graceElapsed.value || showTimer) return;
    showTimer = setTimeout(() => {
      graceElapsed.value = true;
      showTimer = null;
    }, SHOW_DELAY_MS);
  },
  { immediate: true }
);

const showBanner = computed(
  () => !socketConnected.value && isCallInFlight.value && graceElapsed.value
);

onBeforeUnmount(clearShowTimer);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    _createVNode(_Transition, { name: "socket-banner" }, {
      default: _withCtx(() => [
        (showBanner.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_unref(Icon), {
                  icon: "mdi:wifi-off",
                  width: "16",
                  height: "16",
                  class: "socket-banner__icon"
                }),
                _cache[0] || (_cache[0] = _createElementVNode("span", { class: "socket-banner__pulse" }, null, -1))
              ]),
              _cache[1] || (_cache[1] = _createElementVNode("div", { class: "socket-banner__copy" }, [
                _createElementVNode("span", { class: "socket-banner__title" }, [
                  _createTextVNode(" Reconnecting"),
                  _createElementVNode("span", {
                    class: "socket-banner__ellipsis",
                    "aria-hidden": "true"
                  }, [
                    _createElementVNode("span"),
                    _createElementVNode("span"),
                    _createElementVNode("span")
                  ])
                ]),
                _createElementVNode("span", { class: "socket-banner__subtitle" }, "Live captions paused")
              ], -1))
            ]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    })
  ]))
}
}

})